export const allowedRoles = ['USER', 'SERVICE', 'MARKETING']
